export const getLabel = (
  label: string | { [key: string]: string | null },
  language: string
): string => {
  if (!label) {
    return "";
  }
  if (typeof label === "object") {
    return label[language] || "";
  }
  return label;
};
